import React from 'react';
import {IFirebaseAuthUser} from "../interfaces/authentication.interfaces";

const AuthUserContext = React.createContext<IFirebaseAuthUser>(null);

export default AuthUserContext;
